//유저 관점에서 보여야 하는 리포트 목록
//리포트 프리퍼런스를 변경하거나, Coauthors 정보가 변경되는 경우 여기가 변경되어야 함

import * as Sentry from '@sentry/vue';
import { authApi, publicApi } from '../utils/api';
import { buildInviteMailContent, sendMail } from '../utils/mailTemplates';

const report_list = {
  namespaced: true,
  state: {
    report_code: '',
    standard_mode: 'GRI',
    report_list: [
      // {
      //     index: 0,
      //     report_id: 1,
      //     report_code: "r11",
      //     report_name: "GRI Test Report",
      //     created_date: "2020-11-26",
      //     start_date: "2019-01-01",
      //     end_date: "2019-12-31",
      //     published_date: "1900-01-01" // default값을 1900년 1월 1일로 설정해두었습니다.
      //     report_url: "qesg",
      //     organization_id: 1,
      //     organization_name : ''
      //     organization_name_e : ''
      //     address: ''
      //     logo_name: ''
      //     logo_path: ''
      //     featured_image_name: "18blthr4a4pokjpg.jpg",
      //     featured_image_path: "reports\\r11",
      //     state: 0,   // report state: 0 (생성됨) -> 1 (보고 지표 선택됨) -> 2 (작성중) -> 3 (공개됨)
      //     description: ''
      //     using_logo: true,
      //     main_color: "black",
      //     sub_color: "red",
      //     font_family: "malgun-gothic",
      //     font_size: "14",
      //     folded: false,
      //     owner_id: 1,
      //     owner_e_mail: '',
      //     align_option: "core",
      //     type: null,
      //     coauthors: [{
      //         "index": 0,
      //         "coauthor_id": 1,
      //         "report_code": "r11",
      //         "e_mail": "hjkim@qesg.co.kr",
      //         "accepted": true,
      //         "invited_date": "2020-11-03"
      //     }]
      // }
    ],
    is_report_list_loaded: false,
    all_report_list: [],
    viewer_all_report: {},
    viewer_report_code: process.env.VUE_APP_REPORT_CODE ? process.env.VUE_APP_REPORT_CODE : '',
    is_all_report_list_loaded: false,
    lang: 'KOR', //영문일 경우 'ENG'
    view_mode: 'editor', // 'viewer'
    editor_mode: 'standard_index' // 'standard_index', 'story_board'
  },
  mutations: {
    update_report_list(state, new_report_list) {
      state.report_list = new_report_list;
    },
    update_viewer_report(state, new_report_list) {
      state.viewer_all_report = {
        ...state.viewer_all_report,
        ...new_report_list
      };
    },
    add_or_update_report(state, { report_code, new_report_obj }) {
      const temp_report_list = [...state.report_list];
      const idx = temp_report_list.findIndex(item => item.report_code == report_code);
      if (idx > -1) {
        //coauthors가 있기 때문에, 제외하고 나머지 부분을 업데이트 해야 함
        for (const [key, value] of Object.entries(new_report_obj)) {
          temp_report_list[idx][key] = value;
        }

        if (temp_report_list[idx].hasOwnProperty('coauthors') == false) {
          temp_report_list[idx]['coauthors'] = [];
        }
      }
    },
    update_report_name_e(state, new_obj) {
      const temp_report_list = [...state.report_list];
      const idx = temp_report_list.findIndex(x => x.report_code == new_obj.report_code);
      if (idx > -1) {
        temp_report_list[idx]['report_name_e'] = new_obj.report_name_ea;
      }
    },
    update_report_code(state, new_report_code) {
      state.report_code = new_report_code;
    },
    update_viewer_report_code(state, new_viewer_report_code) {
      state.viewer_report_code = new_viewer_report_code;
    },
    update_report_list_loaded(state, flag) {
      state.is_report_list_loaded = flag;
    },
    add_or_update_coauthor(state, { report_code, new_coauthor_obj }) {
      //1. find report
      const temp_report_list = [...state.report_list];
      const idx = temp_report_list.findIndex(item => item.report_code == report_code);
      if (idx > -1) {
        //coauthor 안에 이미 존재하는지 확인하고 추가 또는 업데이트
        const temp_coauthors = temp_report_list[idx].coauthors;
        const author_idx = temp_coauthors.findIndex(item => item.e_mail == new_coauthor_obj.e_mail);
        if (author_idx > -1) {
          temp_coauthors.splice(author_idx, 1, new_coauthor_obj);
          temp_report_list[idx].coauthors = temp_coauthors;
        } else {
          temp_coauthors.push(new_coauthor_obj);
          temp_report_list[idx].coauthors = temp_coauthors;
        }
      }
      //2. state 변경 인식시킴
      state.report_list = temp_report_list;
    },
    delete_coauthor(state, { report_code, target_e_mail }) {
      //1. find report
      const temp_report_list = [...state.report_list];
      const idx = temp_report_list.findIndex(item => item.report_code == report_code);
      if (idx > -1) {
        const temp_coauthors = temp_report_list[idx].coauthors;
        const author_idx = temp_coauthors.findIndex(item => item.e_mail == target_e_mail);
        if (author_idx > -1) {
          temp_coauthors.splice(author_idx, 1);
        }
      }
      //2. state 변경 인식시킴
      state.report_list = temp_report_list;
    },
    delete_report(state, report_code) {
      const idx = state.report_list.findIndex(item => item.report_code == report_code);
      if (idx > -1) {
        state.report_list.splice(idx, 1);
      }
    },
    update_all_report_list_loaded(state, flag) {
      state.is_all_report_list_loaded = flag;
    },
    change_lang(state, new_lang) {
      state.lang = new_lang;
    },
    update_view_mode(state, mode) {
      state.view_mode = mode;
    },
    set_standard_mode(state, mode) {
      state.standard_mode = mode;
    }
  },
  getters: {
    is_viewer(state, getters, rootState, rootGetters) {
      // 중간에 따로 뽑아 캐싱
      return rootGetters.is_viewer;
    },
    current_report_code(state, getters) {
      if (!process.env.VUE_APP_REPORT_CODE) {
        if (!getters.is_viewer) {
          return state.report_code;
        } else {
          return state.viewer_report_code;
        }
      } else {
        return process.env.VUE_APP_REPORT_CODE;
      }
    },
    // report_code ▶ index 맵 생성 (캐싱된 getter)
    report_index_map(state) {
      const map = {};
      state.report_list.forEach((item, idx) => {
        map[item.report_code] = { list: 'report_list', idx };
        if (item.report_url) map[item.report_url] = { list: 'report_list', idx };
      });
      state.all_report_list.forEach((item, idx) => {
        map[item.report_code] = { list: 'all_report_list', idx };
        if (item.report_url) map[item.report_url] = { list: 'all_report_list', idx };
      });
      return map;
    },
    selected_report(state, getters) {
      if (!getters.is_viewer) {
        if (state.report_code === '') {
          return {};
        }
        // MEMO: 새로고침하다보면 getters내부를 계속 순회하면서 빈값이 들어가는 경우가 있음.
        // report_index_map은 백단에서 처리해서 새로 하는게 좋아보임.
        // console.log('editor')
        // const entry = getters.report_index_map[state.report_code];
        // return entry ? state[entry.list][entry.idx] || {} : {};
        let idx = state.report_list.findIndex(item => item.report_code == state.report_code);

        if (idx > -1) {
          return state.report_list[idx];
        }

        idx = state.report_list.findIndex(item => item.report_url == state.report_code);
        if (idx > -1) {
          return state.report_list[idx];
        }

        //report_list (editor)에서 못찾은 경우, viewer 일 수 있으므로 all_list 에서 다시 찾음.
        idx = state.all_report_list.findIndex(item => item.report_code == state.report_code);
        if (idx > -1) {
          return state.all_report_list[idx];
        }

        idx = state.all_report_list.findIndex(item => item.report_url == state.report_code);
        if (idx > -1) {
          return state.all_report_list[idx];
        }

        return {};
      } else {
        return state.viewer_all_report[state.viewer_report_code];
      }
    },

    gri_ver(state) {
      if (state.is_report_list_loaded) {
        const idx = state.report_list.findIndex(item => item.report_code == state.report_code);
        if (idx > -1) {
          if (state.report_list[idx].gri_use == null) {
            return 'not_report';
          }
          return state.report_list[idx].gri_use;
        } else return 'not_report';
      } else {
        return 'not_report';
      }
    },
    tcfd_ver(state) {
      if (state.is_all_report_list_loaded == false) {
        const idx = state.report_list.findIndex(item => item.report_code == state.report_code);
        if (idx > -1) {
          if (state.report_list[idx].tcfd_use == null) {
            return 'not_report';
          }
          return state.report_list[idx].tcfd_use;
        } else return 'not_report';
      } else {
        return 'not_report';
      }
    },
    get_report_name_e(state) {
      const idx = state.report_list.findIndex(item => item.report_code == state.report_code);
      if (idx > -1) {
        if (
          state.report_list[idx].report_name_em != null &&
          state.report_list[idx].report_name_em != undefined
        ) {
          return state.report_list[idx].report_name_em;
        } else if (
          state.report_list[idx].report_name_ea != null &&
          state.report_list[idx].report_name_ea != undefined
        ) {
          return state.report_list[idx].report_name_ea;
        }
      }
    }
  },
  actions: {
    async readReportListByUserId({ commit, rootState, dispatch }, { user_id }) {
      const response = await authApi.get('/read_report_list_by_user_id', {
        params: {
          user_id: user_id
        }
      });

      try {
        if (response?.data.code !== false) {
          const new_report_list = response.data;
          commit('update_report_list', new_report_list);
          commit('update_report_list_loaded', true);
        }
      } catch (error) {
        dispatch('logout', null, { root: true });
        error.message = '[보고서 목록 불러오기]' + error.message;
        Sentry.captureException(error);
        console.log(error);
        alert(`다시 로그인해 주십시오.`);
      }
    },
    readReportListByKeywordFromAdmin(
      { commit, rootState, dispatch },
      { keyword, search_category, user_id, user_id_no }
    ) {
      return authApi
        .post('/read_report_list_by_admin_search', {
          k: keyword,
          user_id: user_id,
          user_id_no: user_id_no,
          search_category: search_category
        })
        .then(response => {
          const new_report_list = response.data;
          commit('update_report_list', new_report_list);
          commit('update_report_list_loaded', true);
        })
        .catch(error => {
          alert(`관리자 로그인이 아닙니다. 다시 로그인해주세요.`);
          dispatch('logout', null, { root: true });
          error.message = '[보고서 검색]' + error.message;
          Sentry.captureException(error);
        });
    },
    async readAllReportListForViewer({ commit, rootState, getters }) {
      if (!getters.is_viewer) {
        return;
      }

      // const urlParams = new URL(location.href).searchParams;
      // let report_url = process.env.VUE_APP_REPORT_CODE
      //   ? process.env.VUE_APP_REPORT_CODE
      //   : urlParams.get('r').split('?')[0] !== null
      //   ? urlParams.get('r').split('?')[0]
      //   : null;

      if (getters.current_report_code) {
        const path =
          '/read_all_report_list_for_viewer?report_url=' + getters.current_report_code ||
          process.env.VUE_APP_REPORT_CODE;

        try {
          commit('update_all_report_list_loaded', false);
          const response = await publicApi.get(path);
          if (response) {
            const new_all_report_list = response.data[0];

            if (new_all_report_list) {
              commit('update_viewer_report', {
                [new_all_report_list.report_code]: new_all_report_list
              });
              commit('update_all_report_list_loaded', true);
              commit('update_view_mode', 'editor');
            } else {
              window.alert('해당 보고서가 존재하지 않거나 공개되지 않았습니다.');
              window.location.href = '/';
            }
          }
        } catch (error) {
          error.message = '[모든 보고서 리스트]' + error.message;
          Sentry.captureException(error);
        }
      } else {
        window.alert('존재하지 않는 보고서입니다.');
        window.location.href = '/';
      }
    },
    saveReportPreference(
      { commit, rootState },
      {
        report_code,
        request_user_id,
        report_name,
        report_subname,
        report_name_em,
        start_date,
        end_date,
        published_date,
        report_url,
        organization_id,
        organization_name,
        organization_name_e,
        registration_code,
        address,
        state,
        description,
        report_type,
        using_logo,
        main_color,
        sub_color,
        font_family,
        font_size,
        folded,
        owner_id,
        align_option,
        plan,
        logo,
        dark_logo,
        featured_image,
        gri_use,
        tcfd_use,
        use_standard_index,
        use_story_board,
        is_dark_option
      }
    ) {
      const formData = new FormData();
      formData.append('report_code', report_code);
      if (request_user_id != null && request_user_id != undefined)
        formData.append('request_user_id', request_user_id);
      if (report_name != null && report_name != undefined)
        formData.append('report_name', report_name);
      if (report_subname != null && report_subname != undefined)
        formData.append('report_subname', report_subname);
      if (report_name_em != null && report_name_em != undefined)
        formData.append('report_name_em', report_name_em);
      if (start_date != null && start_date != undefined) formData.append('start_date', start_date);
      if (end_date != null && end_date != undefined) formData.append('end_date', end_date);
      if (organization_id != null && organization_id != undefined)
        formData.append('organization_id', organization_id); //organization_id를 안보내면 조직을 새로 생성함
      if (published_date != null && published_date != undefined)
        formData.append('published_date', published_date);
      if (report_url != undefined && report_url != null) formData.append('report_url', report_url);
      if (state != null && state != undefined) formData.append('state', state);
      if (description != null && description != undefined)
        formData.append('description', description);

      if (report_type != null && report_type != undefined) {
        for (let i = 0; i < report_type.length; i++) {
          formData.append('report_type[]', report_type[i]);
        }
      }

      if (using_logo != null && using_logo != undefined) formData.append('using_logo', using_logo);
      if (main_color != null && main_color != undefined) formData.append('main_color', main_color);
      if (sub_color != null && sub_color != undefined) formData.append('sub_color', sub_color);
      if (font_family != null && font_family != undefined)
        formData.append('font_family', font_family);
      if (font_size != null && font_size != undefined) formData.append('font_size', font_size);
      if (folded != null && folded != undefined) formData.append('folded', folded);
      if (owner_id != null && owner_id != undefined) formData.append('owner_id', owner_id);
      if (align_option != null && align_option != undefined)
        formData.append('align_option', align_option);
      if (plan != null && plan != undefined) formData.append('plan', plan);

      if (gri_use != null && gri_use != undefined) formData.append('gri_use', gri_use);
      if (tcfd_use != null && tcfd_use != undefined) formData.append('tcfd_use', tcfd_use);

      if (organization_name != null && organization_name != undefined)
        formData.append('organization_name', organization_name);
      if (organization_name_e != null && organization_name_e != undefined)
        formData.append('organization_name_e', organization_name_e);
      if (registration_code != null && registration_code != undefined)
        formData.append('registration_code', registration_code);
      if (address != null && address != undefined) formData.append('address', address);
      if (is_dark_option != null && is_dark_option != undefined)
        formData.append('is_dark_option', is_dark_option);

      if (logo != null && logo != undefined) formData.append('logo', logo, logo.name);
      if (dark_logo != null && dark_logo != undefined)
        formData.append('dark_logo', dark_logo, dark_logo.name);
      if (featured_image != null && featured_image != undefined)
        formData.append('featured_image', featured_image, featured_image.name);

      if (use_standard_index !== null && use_standard_index !== undefined)
        formData.append('standard_index', use_standard_index);
      if (use_story_board !== null && use_story_board !== undefined)
        formData.append('story_board', use_story_board);

      return authApi
        .post('/save_report', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('add_or_update_report', {
            report_code: response.data.report_code,
            new_report_obj: response.data
          });
          return response.data.report_code;
        });
    },
    async inviteCoauthor({ commit, getters }, { report_code, target_e_mail }) {
      const formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('e_mail', target_e_mail);

      const response = await authApi.post('/invite_coauthor', formData);

      if (response.data.code) {
        const new_coauthor_obj = {
          coauthor_id: response.data.coauthor_id,
          report_code: response.data.report_code,
          e_mail: response.data.e_mail,
          accepted: response.data.accepted,
          invited_date: response.data.invited_date,
          is_current_user: response.data.is_current_user,
          user_name: response.data.user_name
          // company_name: response.data.company_name
        };
        commit('add_or_update_coauthor', {
          report_code: report_code,
          new_coauthor_obj: new_coauthor_obj
        });

        try {
          const selectedReport = getters.selected_report || {};
          const mailPayload = buildInviteMailContent({
            recipientEmail: target_e_mail,
            ownerName: selectedReport.owner_name || selectedReport.owner_e_mail || '',
            reportName: selectedReport.report_name || ''
          });
          await sendMail(mailPayload);
        } catch (mailError) {
          console.error('[초대 메일 발송 실패]', mailError);
        }

        return response;
      } else {
        return response;
      }
    },
    kickOutCoauthor({ commit }, { report_code, target_e_mail }) {
      //Coauthor 제거하고, 타깃 리포트에서도 제거토록 함
      const formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('e_mail', target_e_mail);

      return publicApi
        .post('/kick_out_coauthor', formData)
        .then(response => {
          commit('delete_coauthor', {
            report_code: response.data.report_code,
            target_e_mail: response.data.e_mail
          });
        })
        .catch(error => {
          error.message = '[팀원 삭제]' + error.message;
          Sentry.captureException(error);
        });
    },
    deleteReport({ commit, rootState }, { report_code }) {
      const formData = new FormData();
      formData.append('report_code', report_code);

      return authApi
        .post('/delete_report', formData)
        .then(response => {
          if (response.data && response.data.report_code) {
            commit('delete_report', response.data.report_code);
          } else {
            const errorMessage = '[보고서 삭제] - 응답에 report_code가 없습니다.';
            const err = new Error(errorMessage);
            Sentry.captureException(err);
            return Promise.reject(err);
          }
        })
        .catch(error => {
          error.message = '[보고서 삭제]' + error.message;
          Sentry.captureException(error);
        });
    },
    translateReportName({ commit }, { report_code, report_name }) {
      const formData = new FormData();
      formData.append('report_code', report_code);
      formData.append('report_name', report_name);

      return authApi
        .post('/translate_report_name', formData)
        .then(response => {
          commit('update_report_name_e', response.data);
        })
        .catch(error => {
          error.message = '[보고서명 번역]' + error.message;
          Sentry.captureException(error);
        });
    },

    async checkReportPublish({ commit, rootState }, report_url) {
      if (process.env.VUE_APP_REPORT_CODE) {
        commit('update_viewer_report_code', process.env.VUE_APP_REPORT_CODE);
        return;
      }

      try {
        const response = await publicApi.get('/viewer/report_url/' + report_url);
        if (response.data.code) {
          commit('update_viewer_report_code', response.data.report_code);
        } else {
          window.alert(response.data.msg || '해당 보고서가 존재하지 않거나 공개되지 않았습니다.');
          window.location.href = '/';
        }
      } catch (error) {
        const errMsg =
          error.response?.data?.msg || '해당 보고서가 존재하지 않거나 공개되지 않았습니다.';
        window.alert(errMsg);
        window.location.href = '/';
        error.message = '[보고서 공개 여부]' + error.message;
        Sentry.captureException(error);
      }
    }
  }
};

export default report_list;
